import Cookies from 'js-cookie'

export const removeConsentCookie = (id: string, accountId: string): void => {
  Cookies.remove(`AccountConsent-${accountId}-${id}`)
}
